// extracted by mini-css-extract-plugin
export default {"root":"css-baseline_root__RavOC"};